import { USER_LANGUAGE } from '../constants/localStorageKeys';

export default () => localStorage.getItem(USER_LANGUAGE);



// WEBPACK FOOTER //
// ./src/utils/getUserLanguageFromLocalStorage.js